import { render } from "./PolicyComponent.vue?vue&type=template&id=1c2643e8"
import script from "./PolicyComponent.vue?vue&type=script&lang=js"
export * from "./PolicyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__